// empty consent
const EmptyConsent = new Set();

export { EmptyConsent };
//# sourceMappingURL=types.js.map
